// source: pbtypes/gen/flir_boson_driver/boson_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flir_boson_driver_ffc_mode_pb = require('../../../pbtypes/gen/flir_boson_driver/ffc_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_ffc_mode_pb);
var pbtypes_gen_flir_boson_driver_gain_mode_pb = require('../../../pbtypes/gen/flir_boson_driver/gain_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_gain_mode_pb);
goog.exportSymbol('proto.flir_boson_driver.BosonSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flir_boson_driver.BosonSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flir_boson_driver.BosonSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flir_boson_driver.BosonSettings.displayName = 'proto.flir_boson_driver.BosonSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flir_boson_driver.BosonSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.flir_boson_driver.BosonSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flir_boson_driver.BosonSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flir_boson_driver.BosonSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
ffcMode: jspb.Message.getFieldWithDefault(msg, 1, 0),
gainMode: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flir_boson_driver.BosonSettings}
 */
proto.flir_boson_driver.BosonSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flir_boson_driver.BosonSettings;
  return proto.flir_boson_driver.BosonSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flir_boson_driver.BosonSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flir_boson_driver.BosonSettings}
 */
proto.flir_boson_driver.BosonSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.flir_boson_driver.FfcMode.Enum} */ (reader.readEnum());
      msg.setFfcMode(value);
      break;
    case 2:
      var value = /** @type {!proto.flir_boson_driver.GainMode.Enum} */ (reader.readEnum());
      msg.setGainMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flir_boson_driver.BosonSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flir_boson_driver.BosonSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flir_boson_driver.BosonSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flir_boson_driver.BosonSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFfcMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getGainMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional FfcMode.Enum ffc_mode = 1;
 * @return {!proto.flir_boson_driver.FfcMode.Enum}
 */
proto.flir_boson_driver.BosonSettings.prototype.getFfcMode = function() {
  return /** @type {!proto.flir_boson_driver.FfcMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.flir_boson_driver.FfcMode.Enum} value
 * @return {!proto.flir_boson_driver.BosonSettings} returns this
 */
proto.flir_boson_driver.BosonSettings.prototype.setFfcMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional GainMode.Enum gain_mode = 2;
 * @return {!proto.flir_boson_driver.GainMode.Enum}
 */
proto.flir_boson_driver.BosonSettings.prototype.getGainMode = function() {
  return /** @type {!proto.flir_boson_driver.GainMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flir_boson_driver.GainMode.Enum} value
 * @return {!proto.flir_boson_driver.BosonSettings} returns this
 */
proto.flir_boson_driver.BosonSettings.prototype.setGainMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.flir_boson_driver);
